import { render, staticRenderFns } from "./AxFilesystemNavigation.vue?vue&type=template&id=7b2bbce4&scoped=true&"
import script from "./AxFilesystemNavigation.vue?vue&type=script&lang=ts&"
export * from "./AxFilesystemNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./AxFilesystemNavigation.vue?vue&type=style&index=0&id=7b2bbce4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2bbce4",
  null
  
)

export default component.exports